export default __webpack_public_path__ + "static/media/schema.05254e91.jpg";